import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateVisitDTO } from "./type";
import type { Visit } from "@typings/entities/visit";

export async function createVisit(visit: CreateVisitDTO): Promise<Visit> {
  const response = await apiClient.post<Visit>(apiPaths.visits.create, visit);
  return response.data;
}
